module.exports = __webpack_public_path__ + "img/whatsapp.8a404a63.png";